import { useState } from 'react';
import './Login.css';
import { Avatar } from 'antd';
import img3 from '../../images/03.jpg';
import utils from '../../Functions/utils';
import { useNavigate } from "react-router-dom";

function LoginComp() {
  const [mode, setMode] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [fName, setFName] = useState('');
  const [lName, setLName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const resetFields = () => {
    setUsername('');
    setPassword('');
    setFName('');
    setLName('');
    setEmail('');
    setPhone('');
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      setError('יש להזין שם משתמש וסיסמה');
      return;
    }

    if (mode === 'signup' && (!fName.trim() || !lName.trim())) {
      setError('יש להזין שם פרטי ומשפחה');
      return;
    }

    setError('');
    setLoading(true);

    try {
      if (mode === 'login') {
        const resp = await utils.requestData("SignIn", { username, password });

        if (resp[0].code !== 90) {
          localStorage.setItem("auth-token", resp[0].token);
          localStorage.setItem("userId", resp[0].id);
          window.location.reload();
          navigate("/tanya");
        } else {
          setError(resp[0].msg);
        }
      } else {
        const resp = await utils.requestData("SignUp", {
          username,
          password,
          fName,
          lName,
          email,
          phone
        });

        if (resp[0].id > 0) {
          const loginResp = await utils.requestData("SignIn", { username, password });

          if (loginResp[0].code !== 90) {
            localStorage.setItem("auth-token", loginResp[0].token);
            localStorage.setItem("userId", loginResp[0].id);
            window.location.reload();
            navigate("/tanya");
          } else {
            setError("ההרשמה הצליחה, אך ההתחברות נכשלה: " + loginResp[0].msg);
          }
        }
        else {
          setError(resp[0].msg || "שגיאה בהרשמה");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setError("שגיאה בשרת");
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleSubmit}>
        <div className="logo-container">
          <div className="logo-placeholder">
            <Avatar alt="" src={img3} className="full-avatar" />
          </div>
        </div>

        <div className="tabs">
          <button type="button" className={mode === 'login' ? 'active' : ''} onClick={() => setMode('login')}>התחברות</button>
          <button type="button" className={mode === 'signup' ? 'active' : ''} onClick={() => setMode('signup')}>הרשמה</button>
        </div>

        {/* <h2 className="login-title">{mode === 'login' ? 'התחברות' : 'הרשמה'}</h2> */}

        {error && <div className="error-message" role="alert">{error}</div>}

        <div className="form-container">
          <div className="form-group">
            <label className="input-label">שם משתמש</label>
            <input
              type="text"
              className="text-input"
              placeholder="הזן שם משתמש"
              value={username}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z]*$/.test(value)) {
                  setUsername(value);
                }
              }}
              dir="ltr"
            />
          </div>

          <div className="form-group">
            <label className="input-label">סיסמה</label>
            <input
              type="password"
              className="text-input"
              placeholder="הזן סיסמה"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              dir="rtl"
            />
          </div>

          {mode === 'signup' && (
            <>
              <div className="form-group">
                <label className="input-label">שם פרטי</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="הזן שם פרטי"
                  value={fName}
                  onChange={(e) => setFName(e.target.value)}
                  dir="rtl"
                />
              </div>

              <div className="form-group">
                <label className="input-label">שם משפחה</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder="הזן שם משפחה"
                  value={lName}
                  onChange={(e) => setLName(e.target.value)}
                  dir="rtl"
                />
              </div>

              <div className="form-group">
                <label className="input-label">אימייל (לא חובה)</label>
                <input
                  type="email"
                  className="text-input"
                  placeholder="כתובת אימייל"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  dir="rtl"
                />
              </div>

              <div className="form-group">
                <label className="input-label">טלפון (לא חובה)</label>
                <input
                  type="tel"
                  className="text-input"
                  placeholder="מספר טלפון"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  dir="rtl"
                />
              </div>
            </>
          )}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'טוען...' : mode === 'login' ? 'התחבר' : 'הרשם'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default LoginComp;
